import { LOCAL_STORAGE_REFRESH_TOKEN, LOCAL_STORAGE_ACCESS_TOKEN } from '../../../utils/constants';
import { fetchVendorInfo } from '../vendor/asyncThunks';
import {
  signUp,
  login,
  logout,
  verifyEmail,
  sendRecoveryCodeForgotPassword,
  changePassword,
  renewCodeForVendor,
} from './asyncThunks';

export const signUpBuilder = builder => {
  builder.addCase(signUp.pending, state => {
    state.createAccountPending = true;
  });
  builder.addCase(signUp.fulfilled, (state, action) => {
    const { accessToken, refreshToken } = action.payload;
    state.createAccountPending = false;
    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken);
    localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
    state.loggedIn = true;
  });
  builder.addCase(signUp.rejected, state => {
    state.createAccountPending = false;
  });
};

export const loginBuilder = builder => {
  builder.addCase(login.pending, state => {
    state.loginPending = true;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { accessToken, refreshToken } = action.payload;
    state.loginPending = false;
    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken);
    localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
    state.loggedIn = true;
  });
  builder.addCase(login.rejected, state => {
    state.loginPending = false;
  });
};

export const fetchVendorInfoBuilder = builder => {
  builder.addCase(fetchVendorInfo.fulfilled, state => {
    state.loggedIn = true;
  });
  builder.addCase(fetchVendorInfo.rejected, state => {
    state.loggedIn = false;
  });
};

export const logoutBuilder = builder => {
  builder.addCase(logout.pending, state => {
    state.loggedIn = false;
  });
  builder.addCase(logout.fulfilled, state => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
  builder.addCase(logout.rejected, state => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
};

export const verifyEmailBuilder = builder => {
  builder.addCase(verifyEmail.pending, state => {
    state.verifyEmailPending = true;
  });
  builder.addCase(verifyEmail.fulfilled, (state, action) => {
    const { email } = action.payload;

    state.verifyEmailPending = false;
    state.email = email;
  });
  builder.addCase(verifyEmail.rejected, state => {
    state.verifyEmailPending = false;
  });
};
export const sendRecoveryCodeForgotPasswordBuilder = builder => {
  builder.addCase(sendRecoveryCodeForgotPassword.pending, state => {
    state.sendRecoveryCodeForgotPasswordPending = true;
  });
  builder.addCase(sendRecoveryCodeForgotPassword.fulfilled, (state, action) => {
    const { email } = action.payload;

    state.sendRecoveryCodeForgotPasswordPending = false;
    state.email = email;
  });
  builder.addCase(sendRecoveryCodeForgotPassword.rejected, state => {
    state.sendRecoveryCodeForgotPasswordPending = false;
  });
};

export const changePasswordBuilder = builder => {
  builder.addCase(changePassword.pending, state => {
    state.changePasswordPending = true;
  });
  builder.addCase(changePassword.fulfilled, state => {
    state.changePasswordPending = false;
  });
  builder.addCase(changePassword.rejected, (state, action) => {
    state.changePasswordPending = false;
    state.error = action.error.message;
  });
};

export const renewCodeForVendorBuilder = builder => {
  builder.addCase(renewCodeForVendor.pending, state => {
    state.renewCodeForVendorPending = true;
  });
  builder.addCase(renewCodeForVendor.fulfilled, state => {
    state.renewCodeForVendorPending = false;
  });
  builder.addCase(renewCodeForVendor.rejected, (state, action) => {
    state.renewCodeForVendorPending = false;
    state.error = action.error.message;
  });
};
